<div class="tcg-page">
  <div class="tcg-table-toolbar">
    <button type="button" class="tcg-us-back" (click)="onBackClick()">
      ← Back to Test Suites
    </button>
  </div>

  <div class="tcg-loading-wrapper" *ngIf="loading$ | async; else accordionBlock">
    <app-loading [text]="'Loading data..'"></app-loading>
  </div>

  <ng-template #accordionBlock>
    <app-expandable-accordion
      [data]="(accordionData$ | async) ?? { columns: [], rows: [] }"
      [showEmptyState]="true"
      [showSelectAll]="true"
      [showFeedbackActions]="showAddToSuite && !isImportFlow"
      [showStoryIdLink]="!showAddToSuite"
      [showEditButton]="!showAddToSuite"
      [showFilterButton]="true"
      [filterActive]="(isFilterActive$ | async) ?? false"
      [showDownloadButton]="true"
      [showDeleteButton]="!showAddToSuite"
      [showAddMissingButton]="true"
      [addMissingIsDropdown]="true"
      [showAddToSuiteButton]="showAddToSuite"
      [feedbackSubmitting]="isUpdatingFeedback"
      [pageSize]="6"
      (actionEmit)="onAccordionAction($event)"
    ></app-expandable-accordion>
  </ng-template>
</div>
